module.exports = __webpack_public_path__ + "static/img/20009 (7).b519fc5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20009 (7).webp
// module id = zKKZ
// module chunks = 14